<template>
  <template v-if="hasAlert">
    <div class="fixed right-0 top-0 pt-14">
      <div
        class="flex flex-col items-start justify-start space-y-2"
      >
        <template v-if="isLowBattery">
          <div
            class="flex size-10 flex-col items-center justify-center rounded-l-lg bg-background text-error shadow"
          >
            <IconBatteryLow />
            <span class="text-xs font-medium">
              {{
                formatToPercentage(batteryLevel * 100, {
                  compact: true,
                })
              }}
            </span>
          </div>
        </template>
        <template v-else-if="isBatteryCharging">
          <div
            class="flex size-10 flex-col items-center justify-center rounded-l-lg bg-background text-info shadow"
          >
            <IconBatteryCharging />
            <span class="text-xs font-medium">
              {{
                formatToPercentage(batteryLevel * 100, {
                  compact: true,
                })
              }}
            </span>
          </div>
        </template>
        <template v-if="isDisconnected">
          <button
            type="button"
            class="flex size-10 items-center justify-center rounded-l-lg bg-background p-2 text-error shadow"
            @click="wifiSettingsDrawerIsOpen = true"
          >
            <IconWifiOff class="size-6" />
          </button>
        </template>
      </div>
    </div>
  </template>

  <WifiSettingsDrawer
    :is-open="wifiSettingsDrawerIsOpen"
    @close="wifiSettingsDrawerIsOpen = false"
  />
</template>

<script setup lang="ts">
import { useNetwork } from "@vueuse/core"
import { useBattery } from "@vueuse/core"

const wifiSettingsDrawerIsOpen = ref(false)
const { level: batteryLevel, charging: isBatteryCharging } =
  useBattery()

const { isOnline } = useNetwork()
const isLowBattery = computed(
  () =>
    batteryLevel.value <= 0.1 &&
    isBatteryCharging.value === false
)

const isDisconnected = computed(() => !isOnline.value)

const numberOfAlerts = computed(
  () =>
    Number(isLowBattery.value) +
    Number(isDisconnected.value)
)

const hasAlert = computed(() => numberOfAlerts.value >= 1)
</script>
